import { LAYOUTS, POSITION } from '@voltmoney/types';
import { ROUTE } from '../../../routes';
import { ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, SizeTypeTokens, StackAlignContent, StackAlignItems, StackJustifyContent, StackSelfContent, StackType, StackWidth, TextAlignTokens, WIDGET } from "@voltmoney/schema";
import { ACTION } from "./types";
import { callDigioAgain, contactUs, goToNextStep, onLoadRedirection, successVerification, } from "./action";
import { api } from "../../../configs/api";
import { getAppHeader } from "../../../configs/config";
import { Platform } from "react-native";
import { getParameters } from "../../../configs/utils";
export const template = async (isSuccess, isFromInvestWellSDK) => {
    return {
        layout: {
            id: ROUTE.DIGIO_AUTOPAY_REDIRECTION,
            type: LAYOUTS.LIST,
            widgets: [
                { id: "mainContainerStack", type: WIDGET.STACK },
                isSuccess && !isFromInvestWellSDK ? {} : {
                    id: "bottomStack",
                    type: WIDGET.STACK,
                    position: POSITION.ABSOLUTE_BOTTOM
                },
                isSuccess && !isFromInvestWellSDK ? {} : { id: "space24", type: WIDGET.SPACE }
            ],
        },
        datastore: {
            mainContainerStack: {
                type: StackType.column,
                justifyContent: StackJustifyContent.center,
                alignContent: StackAlignContent.center,
                alignSelf: StackSelfContent.center,
                alignItems: StackAlignItems.center,
                padding: {
                    left: SizeTypeTokens.MD,
                    right: SizeTypeTokens.MD
                },
                widgetItems: [
                    { id: "space80", type: WIDGET.SPACE },
                    { id: "space80", type: WIDGET.SPACE },
                    { id: "space24", type: WIDGET.SPACE },
                    { id: "errorIcon", type: WIDGET.ICON },
                    { id: "space16", type: WIDGET.SPACE },
                    { id: "errorText", type: WIDGET.TEXT },
                    { id: "space16", type: WIDGET.SPACE },
                    { id: "errorDescription", type: WIDGET.TEXT },
                    { id: "space24", type: WIDGET.SPACE },
                    isSuccess ? { id: "continueToAgreementButton", type: WIDGET.BUTTON } : {
                        id: "retryDigioButton",
                        type: WIDGET.BUTTON
                    },
                ]
            },
            errorIcon: {
                name: isSuccess ? IconTokens.Success : IconTokens.ErrorIcon,
                size: IconSizeTokens.XXXXXXL,
            },
            errorText: {
                label: isSuccess ? 'Agreement done successfully!' : 'Agreement request failed',
                fontSize: FontSizeTokens.MD,
                fontFamily: FontFamilyTokens.Poppins,
                fontWeight: '600',
                lineHeight: 24,
                color: ColorTokens.Grey_Night
            },
            errorDescription: {
                label: isSuccess ?
                    'You will be redirected to next step in few seconds' :
                    'We encountered an error while signing the loan agreement. Please retry the process.',
                fontSize: FontSizeTokens.SM,
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: '400',
                lineHeight: 20,
                color: ColorTokens.Grey_Night,
                textAlign: TextAlignTokens.center,
            },
            bottomStack: {
                type: StackType.column,
                width: StackWidth.MATCH_PARENT,
                alignItems: StackAlignItems.center,
                alignSelf: StackSelfContent.center,
                widgetItems: [
                    { id: "needAccessLinkStack", type: WIDGET.STACK }
                ],
                action: {
                    routeId: ROUTE.DIGIO_AUTOPAY_REDIRECTION,
                    type: ACTION.CONTACT_US
                }
            },
            retryDigioButton: {
                type: ButtonTypeTokens.LargeSoftFilled,
                label: 'Retry agreement review',
                fontSize: FontSizeTokens.SM,
                fontFamily: FontFamilyTokens.Inter,
                width: ButtonWidthTypeToken.FULL,
                action: {
                    type: ACTION.RETRY_DIGIO,
                    routeId: ROUTE.DIGIO_AUTOPAY_REDIRECTION
                }
            },
            continueToAgreementButton: {
                type: ButtonTypeTokens.LargeSoftFilled,
                label: 'Continue',
                fontSize: FontSizeTokens.SM,
                fontFamily: FontFamilyTokens.Inter,
                width: ButtonWidthTypeToken.FULL,
                action: {
                    type: ACTION.GO_TO_NEXT_STEP,
                    routeId: ROUTE.DIGIO_AUTOPAY_REDIRECTION
                }
            },
            needAccessText: {
                label: 'Need help?',
                fontSize: FontSizeTokens.SM,
                fontWeight: '400',
                lineHeight: 20,
                fontFamily: FontFamilyTokens.Inter,
                textAlign: TextAlignTokens.center
            },
            needAccessLinkStack: {
                type: StackType.row,
                width: StackWidth.CONTENT,
                justifyContent: StackJustifyContent.center,
                widgetItems: [
                    { id: "needAccessText", type: WIDGET.TEXT },
                    { id: "needAccessLink", type: WIDGET.TEXT }
                ]
            },
            needAccessLink: {
                label: ' Contact us',
                color: ColorTokens.Primary_100,
                fontSize: FontSizeTokens.SM,
                fontWeight: '600',
                lineHeight: 20,
                fontFamily: FontFamilyTokens.Inter,
            },
            space80: {
                size: SizeTypeTokens.Size80
            },
            space24: {
                size: SizeTypeTokens.XXXL
            },
            space16: {
                size: SizeTypeTokens.XL
            }
        },
    };
};
export const digioAgreementFailureMF = {
    onLoad: async ({ instrumentTrack, network, setDatastore }, { stepResponseObject }) => {
        const user = await network.post(api.userContext, {}, {
            headers: await getAppHeader(),
        });
        const isSuccess = false;
        const url = Platform.OS === 'web' ? window.location.href : '';
        const isPartnerPlatform = url.toLowerCase().includes('partnerplatform');
        const SDK_INVESTWELL = 'SDK_INVESTWELL';
        const params = Platform.OS === 'web' ? getParameters(url) : {};
        const platform = params?.platform;
        const isFromInvestWellSDK = isPartnerPlatform && platform === SDK_INVESTWELL;
        return Promise.resolve(template(isSuccess, isFromInvestWellSDK));
    },
    actions: {
        [ACTION.CONTACT_US]: contactUs,
        [ACTION.RETRY_DIGIO]: callDigioAgain,
        [ACTION.ON_LOAD]: onLoadRedirection,
        [ACTION.GO_TO_NEXT_STEP]: goToNextStep,
        [ACTION.SUCCESS_VERIFICATION]: successVerification,
    },
    action: {
        type: ACTION.ON_LOAD,
        routeId: ROUTE.DIGIO_AUTOPAY_REDIRECTION,
        payload: {}
    },
    clearPrevious: true,
};
